
import { IdentifiedConflictsDTO } from './identifiedConflicts.model';

export class MassAddCourseRequestsDTO {
    identifiedConflicts: IdentifiedConflictsDTO[] = [];
    addedCourseRequests: AddedCourseRequestsDTO[] = [];
    modifiedCourseRequests: ModifiedCourseRequestsDTO[] = [];
}

export class AddedCourseRequestsDTO {
    ID: number;
    Student_ID: number;
    DistrictCourse_ID: number;
}

export class ModifiedCourseRequestsDTO {
    ID: number;
    Modification: string;
    Student_ID: number;
    DistrictCourse_ID: number;
}

export class CourseRequestStudentSummaryModel {
    Student_Id: number;
    LastName: string;
    FirstName: string;
    StudentNumber: string;
    GradeIdentifier: string;
    SumOfEarnedCredit: number;
    NoOfFailedCourse: number;
    NoOfRequestCourse: number;
    SumOfRequestCredit: number;
    NoOfUnmetRequirement: number;
    NoOfConflictRequest: number;
    NoOfRequestReview: number;
    NoOfScheduledCourse: number;
    PrimaryCounselorId: number;
    SumOfScheduledCredit: number;
    StudentCourseRequestedAndScheduledDetails: StudentCourseRequestedAndScheduledDetailDTO[] = [];
    detailRow: boolean;
    displayRequestCourseCredit: string;
    displayScheduledCourseCredit: string;
}

export class StudentCourseRequestedAndScheduledDetailDTO {
    CourseRequestStudentCourseRequests_ID: number;
    Student_Id: number;
    SchoolCourses_ID: number;
    DistrictCourse_ID: number;
    RequestNbr: number; // instance of a request, to multiple requests for the same SchoolCourses_ID
    CourseFormattedName: string;
    CourseRequirementName: string;
    Credits: number;
    TermType: string;
    isScheduled: boolean;
    Classes_ID: number;
    ClassName: string;
    MeetingPatterns: string;
    ClassRooms: string;
    ClassPeriods: string;
    Teachers: string;
    Terms: string;
    ShceduledStudentCountInClass: number;
    isNewlyRequested: boolean; // True if request has been added via student summary detail
    Type: string;
    Status: string;
    LinkedAlternate: string;
}

export class CourseRequestStudentSummaryFilterModel {
    students: number[] = [];
    specialFilter: CourseRequestStudentSummarySpecialStudentFilterModel = null;
    gradeLevels = [];
    requestCoursesMin: number = null;
    requestCoursesMax: number = null;
    requestCreditsMin: number = null;
    requestCreditsMax: number = null;
    scheduledCoursesMin: number = null;
    scheduledCoursesMax: number = null;
    scheduledCreditsMin: number = null;
    scheduledCreditsMax: number = null;
    selectedCounselorId = 0;
    requestCourses: number[] = [];
    missing_requestCourses: number[] = [];
    scheduledCourses: number[] = [];
    missing_scheduledCourses: number[] = [];
    conflict_selectedCourseNameNumber = '';
    conflict_selectedConflictingCourseNameNumber = '';
}

export class CourseRequestStudentSummarySpecialStudentFilterModel {
    filterGroup: string;
    rowHeaderName: string;
    rowHeaderValue: number | string;
    columnHeaderName: string;
    columnHeaderValue: string;
    filterDescription: string;
}
